import { ProfessionsService } from 'data/services';
import { ProfessionsServiceInterface } from 'domain/services';
import { makeRemoteGetAllProfessions } from 'main/factories/usecases/professions/get-all-professions-factory';

export const makeProfessionsService = (): ProfessionsServiceInterface => {
  return new ProfessionsService({
    getAllProfessions: makeRemoteGetAllProfessions(),
  });
};
